// custom-lightbox.js (ESM / Rollup)
// Bootstrap Modal direkt importieren (kein globales `bootstrap` nötig)
import Modal from "bootstrap/js/dist/modal";

document.addEventListener("DOMContentLoaded", () => {
    "use strict";

    // =========================
    // Config
    // =========================
    const LINK_SELECTOR = "a.lightbox";
    const REL_GROUP_REGEX = /^lightbox\[(.+?)\]$/; // z.B. lightbox[65]
    const FADE_MS = 120;

    // =========================
    // Modal DOM dynamisch erstellen
    // =========================
    const modalEl = document.createElement("div");
    modalEl.className = "modal fade custom-lightbox";
    modalEl.id = "dynamicLightboxModal";
    modalEl.tabIndex = -1;
    modalEl.setAttribute("aria-hidden", "true");

    modalEl.innerHTML = `
  <div class="modal-dialog modal-dialog-centered modal-fullscreen-md-down modal-xl">
    <div class="modal-content">
      <div class="modal-body p-0 d-flex align-items-center justify-content-center">

        <!-- Close -->
        <button type="button"
                class="lightbox-close"
                aria-label="Schließen"
                data-lightbox-close>
          <span aria-hidden="true">&times;</span>
        </button>

        <!-- Prev/Next -->
        <button aria-label="Vorheriges Bild" 
            class="lightbox-prev"
            data-lightbox-prev
            type="button">          
        </button>

        <button aria-label="Nächstes Bild"
            class="lightbox-next"
            data-lightbox-next
            type="button">
        </button>

        <!-- Image -->
        <img id="dynamicLightboxImage"
             src=""
             alt=""
             class="img-fluid lightbox-image" />

        <!-- Caption -->
        <div class="lightbox-caption-wrap">
          <div id="dynamicLightboxCaption" class="lightbox-caption"></div>
        </div>

      </div>
    </div>
  </div>
`;

    document.body.appendChild(modalEl);

    // =========================
    // Bootstrap Modal init (ESM)
    // =========================
    const bsModal = new Modal(modalEl, {
        backdrop: true,
        focus: true,
        keyboard: true, // ESC
    });

    const imgEl = modalEl.querySelector("#dynamicLightboxImage");
    const captionEl = modalEl.querySelector("#dynamicLightboxCaption");
    const btnPrev = modalEl.querySelector("[data-lightbox-prev]");
    const btnNext = modalEl.querySelector("[data-lightbox-next]");
    const btnClose = modalEl.querySelector("[data-lightbox-close]");

    // =========================
    // State
    // =========================
    let galleryLinks = [];
    let currentIndex = -1;
    let lastActiveElement = null;

    // Touch / Swipe
    let touchStartX = null;
    let touchStartY = null;

    // =========================
    // Helpers
    // =========================
    function getGroupKeyFromRel(rel) {
        if (!rel) return null;
        const m = rel.match(REL_GROUP_REGEX);
        return m ? m[1] : null;
    }

    function getCaptionFromLink(link) {
        // Priorität: a[title] -> img[title] -> img[alt]
        const aTitle = link.getAttribute("title");
        if (aTitle && aTitle.trim()) return aTitle.trim();

        const img = link.querySelector("img");
        if (img) {
            const imgTitle = img.getAttribute("title");
            if (imgTitle && imgTitle.trim()) return imgTitle.trim();

            const alt = img.getAttribute("alt");
            if (alt && alt.trim()) return alt.trim();
        }
        return "";
    }

    function preload(url) {
        if (!url) return;
        const i = new Image();
        i.src = url;
    }

    function setNavVisibility() {
        const hasGallery = galleryLinks.length > 1;
        btnPrev.style.display = hasGallery ? "" : "none";
        btnNext.style.display = hasGallery ? "" : "none";
    }

    function setCaption(text) {
        const t = (text || "").trim();
        captionEl.textContent = t;
        captionEl.style.display = t ? "" : "none";
    }

    function fadeInImage() {
        imgEl.style.opacity = "0";
        requestAnimationFrame(() => {
            imgEl.style.opacity = "1";
        });
    }

    function showAt(index) {
        if (!galleryLinks.length) return;

        if (index < 0) index = galleryLinks.length - 1;
        if (index >= galleryLinks.length) index = 0;

        currentIndex = index;
        const link = galleryLinks[currentIndex];

        const url = link.getAttribute("href");
        const caption = getCaptionFromLink(link);

        imgEl.style.opacity = "0";
        imgEl.alt = caption || "Bild";
        setCaption(caption);

        imgEl.onload = () => fadeInImage();
        imgEl.onerror = () => {
            setCaption("Bild konnte nicht geladen werden.");
            fadeInImage();
        };

        imgEl.src = url;

        if (galleryLinks.length > 1) {
            const prevUrl =
                galleryLinks[(currentIndex - 1 + galleryLinks.length) % galleryLinks.length]?.getAttribute("href");
            const nextUrl =
                galleryLinks[(currentIndex + 1) % galleryLinks.length]?.getAttribute("href");
            preload(prevUrl);
            preload(nextUrl);
        }

        setNavVisibility();
    }

    function openLightboxForLink(link) {
        lastActiveElement = document.activeElement;

        const rel = link.getAttribute("rel");
        const groupKey = getGroupKeyFromRel(rel);

        if (groupKey) {
            galleryLinks = Array.from(document.querySelectorAll(LINK_SELECTOR)).filter(
                (a) => getGroupKeyFromRel(a.getAttribute("rel")) === groupKey
            );
            currentIndex = galleryLinks.indexOf(link);
        } else {
            galleryLinks = [link];
            currentIndex = 0;
        }

        showAt(currentIndex);
        bsModal.show();
    }

    function closeLightbox() {
        bsModal.hide();
    }

    function next() {
        if (!galleryLinks.length) return;
        showAt(currentIndex + 1);
    }

    function prev() {
        if (!galleryLinks.length) return;
        showAt(currentIndex - 1);
    }

    // =========================
    // Event Delegation: Klick auf a.lightbox
    // =========================
    document.addEventListener("click", (e) => {
        const link = e.target.closest(LINK_SELECTOR);
        if (!link) return;

        // Nur links öffnen (keine Modifier-Klicks)
        if (e.button !== 0) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

        e.preventDefault();
        openLightboxForLink(link);
    });

    // =========================
    // Modal Buttons
    // =========================
    btnClose.addEventListener("click", closeLightbox);
    btnNext.addEventListener("click", next);
    btnPrev.addEventListener("click", prev);

    // Klick auf Bild = schließen (optional)
    imgEl.addEventListener("click", closeLightbox);

    // =========================
    // Tastatursteuerung
    // =========================
    document.addEventListener("keydown", (e) => {
        if (!modalEl.classList.contains("show")) return;

        if (e.key === "ArrowRight") {
            e.preventDefault();
            next();
        } else if (e.key === "ArrowLeft") {
            e.preventDefault();
            prev();
        }
    });

    // =========================
    // Swipe Support (Mobile)
    // =========================
    modalEl.addEventListener(
        "touchstart",
        (e) => {
            if (!e.touches || e.touches.length !== 1) return;
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
        },
        { passive: true }
    );

    modalEl.addEventListener(
        "touchend",
        (e) => {
            if (touchStartX === null || touchStartY === null) return;

            const touch = e.changedTouches && e.changedTouches[0];
            if (!touch) return;

            const dx = touch.clientX - touchStartX;
            const dy = touch.clientY - touchStartY;

            touchStartX = null;
            touchStartY = null;

            if (Math.abs(dx) < 50) return;
            if (Math.abs(dy) > 80) return;

            if (dx < 0) next();
            else prev();
        },
        { passive: true }
    );

    // =========================
    // Focus/cleanup on close
    // =========================
    modalEl.addEventListener("hidden.bs.modal", () => {
        imgEl.onload = null;
        imgEl.onerror = null;
        imgEl.src = "";
        setCaption("");
        galleryLinks = [];
        currentIndex = -1;

        if (lastActiveElement && typeof lastActiveElement.focus === "function") {
            lastActiveElement.focus();
        }
    });

    // =========================
    // Optional: Styles per JS
    // =========================
    const style = document.createElement("style");
    style.textContent = `
    #dynamicLightboxModal .modal-content { pointer-events: none; }
    #dynamicLightboxModal .modal-body,
    #dynamicLightboxModal button,
    #dynamicLightboxModal img,
    #dynamicLightboxModal #dynamicLightboxCaption { pointer-events: auto; }

    a.lightbox img { cursor: zoom-in; }
    #dynamicLightboxModal img { cursor: zoom-out; }

    #dynamicLightboxModal [data-lightbox-prev],
    #dynamicLightboxModal [data-lightbox-next] { user-select: none; }
  `;
    document.head.appendChild(style);
});
